import axios from 'axios';
import FormData from 'form-data';
import BaseService from "./BaseService";
import LogUtils from "../utils/LogUtils";
import settings from "../settings/settings";

class PicturesService extends BaseService {

  constructor() {
    super();
    this.TAG = "PicturesService";

    this.logUtils = new LogUtils();
  }

  async getPictureById(userId, pictureId) {
    let picture = null;

    try {
      const response = this.getResponse(await axios(this.getBasicHttpRequest(
        this.HTTP_METHODS.GET,
        `${settings.MANAGEMENT_SERVICE_URL}/pictures?userId=${userId}&pictureId=${pictureId}`,
        this.getDefaultHeaders(true)
      )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: response.error ? response.error : "Não foi possível retornar a foto"
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Não foi possível retornar a foto"
        };
      }

      picture = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to getPictureById", err);

      return {
        status: -2,
        msg: this.parseError(err)
      };
    }

    return {
      status: 1,
      msg: "A foto foi retornada com sucesso",
      data: picture
    };
  }

  async createPicture(file, userId, description) {
    var newPicture = null;

    try {
      var data = new FormData();
      data.append('file', file);
      data.append('userId', userId);
      data.append('description', description);

      const response = this.getResponse(await axios(this.getBasicHttpRequest(
        this.HTTP_METHODS.POST,
        `${settings.MANAGEMENT_SERVICE_URL}/pictures`,
        this.getDefaultHeaders(true),
        data,
        true
      )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: "Não foi possível criar a imagem"
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Não foi possível criar a imagem"
        };
      }

      newPicture = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to createPicture", err);

      return {
        status: -2,
        msg: this.parseError(err)
      };
    }

    return {
      status: 1,
      msg: "A image foi criada com sucesso!",
      data: newPicture
    };
  }

  async updatePicture(file, userId, pictureId, description) {
    var newPicture = null;

    try {
      var data = new FormData();
      data.append('file', file);
      data.append('userId', userId);
      data.append('pictureId', pictureId);
      data.append('description', description);

      const response = this.getResponse(await axios(this.getBasicHttpRequest(
        this.HTTP_METHODS.PUT,
        `${settings.MANAGEMENT_SERVICE_URL}/pictures`,
        this.getDefaultHeaders(true),
        data,
        true
      )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: "Não foi possível atualizar a imagem"
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Não foi possível atualizar a imagem"
        };
      }

      newPicture = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to updatePicture", err);

      return {
        status: -2,
        msg: this.parseError(err)
      };
    }

    return {
      status: 1,
      msg: "A image foi atualizada com sucesso!",
      data: newPicture
    };
  }

  async upsertPicture({ pictureId, pickedImgFile, currentUserId }) {
    if (!pictureId) {
      return await this.createPicture(pickedImgFile, currentUserId, "picture");
    }

    const resOpPicture = await this.getPictureById(currentUserId, pictureId);

    if (!resOpPicture?.data) {
      return await this.createPicture(pickedImgFile, currentUserId, "picture");
    }
    
    return await this.updatePicture(pickedImgFile, currentUserId, pictureId, "picture");
  }

}

export default PicturesService;